import { useEffect, useState } from "react";
import ProjectWidgetRow from "../../base/components/ProjectWidgetRow";
import { ProjectModel } from "../../base/models/projectModel";
import { fetchProjects } from "../../base/service/service";
import { AboutMeWidget } from "../aboutMe/AboutMeView";

export const HomeView = () => {
  const [projects, setProjects] = useState<ProjectModel[]>();

  useEffect(() => {
    const fetchData = async () => {
      const data = await fetchProjects({});
      setProjects(data);
    };

    fetchData();
  }, []);

  return (
    <div className="inline-flex flex-col gap-5 text-justify w-full ">
      
        <AboutMeWidget />
      
        <div className="h-3/4">
            <h3>Latest Projects</h3>
            <hr className="border-t border-black" />
            {projects?.map((project, index) =>
              project.category.key !== "cadDesign" &&
              project.category.key !== "productDesign" &&
              index < 4 ? (
                <ProjectWidgetRow key={project.key} project={project} />
              ) : null
            )}
          </div>
    </div>
  );
};
